export default "__VITE_ASSET__CuApOyIv__"